import React from 'react';
import { BookOpenIcon, BellIcon, HeartIcon, StarIcon, SearchIcon, HeadphonesIcon, CalendarIcon, PenToolIcon, BriefcaseIcon, WrenchIcon, PencilIcon, BookIcon, HelpCircleIcon, UsersIcon } from 'lucide-react';
import { FilterSidebar, FilterSection, NavItem } from '../UI/FilterSidebar';
import { useUserRole } from '../../context/UserRoleContext';
interface TroveSidebarProps {
  filterSections?: FilterSection[];
  onResetFilters?: () => void;
  className?: string;
  showServiceCategories?: boolean;
}
export const TroveSidebar: React.FC<TroveSidebarProps> = ({
  filterSections = [],
  onResetFilters = () => {},
  className = '',
  showServiceCategories = false
}) => {
  const {
    isReader
  } = useUserRole();
  const navigation: NavItem[] = [{
    label: 'All Articles & News',
    href: '/trove',
    icon: BookOpenIcon
  }, {
    label: 'Updates',
    href: '/trove/updates',
    icon: BellIcon
  }, {
    label: 'Genre Spotlights',
    href: '/trove/genres',
    icon: HeartIcon
  }, {
    label: 'Audio & Narration',
    href: '/trove/audio',
    icon: HeadphonesIcon
  }, {
    label: 'Industry Events',
    href: '/trove/events',
    icon: CalendarIcon
  }, {
    label: 'Services Hub',
    href: '/trove/services',
    icon: WrenchIcon
  },
  // Role-specific last item
  isReader ? {
    label: 'Story in Your Head',
    href: '/trove/story-in-your-head',
    icon: PenToolIcon
  } : {
    label: 'Author Launchpad',
    href: '/trove/author-launchpad',
    icon: BriefcaseIcon
  }];
  const serviceCategoryFilters: FilterSection[] = showServiceCategories ? [{
    id: 'service-categories',
    title: 'Service Categories',
    type: 'checkbox',
    value: [],
    onChange: () => {},
    options: [{
      value: 'editing',
      label: 'Editing'
    }, {
      value: 'production',
      label: 'Production'
    }, {
      value: 'cover-design',
      label: 'Cover Design'
    }, {
      value: 'narration',
      label: 'Narration'
    }, {
      value: 'support',
      label: 'Support Services'
    }, {
      value: 'readers',
      label: 'Reader Services'
    }]
  }] : [];
  return <FilterSidebar title="Trove Navigation" navigation={navigation} sections={[...serviceCategoryFilters, ...filterSections]} onReset={onResetFilters} searchable={false} className={className} data-id="element-3535" data-mp="3c8fixqdyy9og" />;
};